// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import platformSingleton from '../../platform/platformSingleton';
import { isPlatformElectronMac } from '../../platform/utils/platformDetailsUtils';

// Selectors
import { selectUnsavedCommentsOnCurrentBoardCount } from './store/commentsInputSelector';

// Actions
import { electronClearCloseMessage, electronSetCloseMessage } from '../../../common/electron/electronActions';

const USER_PROMPT_MESSAGE = 'Unsaved comments will be lost if you close this window';

const mapDispatchToProps = (dispatch) => ({
    dispatchSetCloseMessage: () =>
        dispatch(
            electronSetCloseMessage({
                message: USER_PROMPT_MESSAGE,
                title: 'Unsaved comments',
            }),
        ),
    dispatchClearCloseMessage: () => dispatch(electronClearCloseMessage()),
});

let UnsavedCommentWindowCloseBlocker = (props) => {
    React.useEffect(() => {
        const { dispatchSetCloseMessage, dispatchClearCloseMessage } = props;

        const onBeforeUnload = (event) => {
            const returnValue = USER_PROMPT_MESSAGE;
            event.returnValue = returnValue;
            return returnValue;
        };

        const isElectron = isPlatformElectronMac(platformSingleton);

        window.addEventListener('beforeunload', onBeforeUnload);
        if (isElectron && dispatchSetCloseMessage) dispatchSetCloseMessage();

        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
            if (isElectron && dispatchClearCloseMessage) dispatchClearCloseMessage();
        };
    }, []);

    return null;
};

UnsavedCommentWindowCloseBlocker.propTypes = {
    dispatchSetCloseMessage: PropTypes.func,
    dispatchClearCloseMessage: PropTypes.func,
};

UnsavedCommentWindowCloseBlocker = connect(null, mapDispatchToProps)(UnsavedCommentWindowCloseBlocker);

const mapStateToProps = createStructuredSelector({
    unsavedCommentsCount: selectUnsavedCommentsOnCurrentBoardCount,
});

const UnsavedCommentWindowCloseBlockerConditional = ({ unsavedCommentsCount }) =>
    unsavedCommentsCount > 0 ? <UnsavedCommentWindowCloseBlocker /> : null;

UnsavedCommentWindowCloseBlockerConditional.propTypes = {
    unsavedCommentsCount: PropTypes.number,
};

export default connect(mapStateToProps)(UnsavedCommentWindowCloseBlockerConditional);
